<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import PageHeader from "../components/PageHeader.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import ClientControl from "../components/controls/ClientControl.svelte";
    import SampleTypeControl from "./SampleTypeControl.svelte";
    import SampleCharacterizationControl from "./SampleCharacterizationControl.svelte";
    import AnalysesSelectControl from "../components/controls/AnalysesSelectControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    // import AnalysesSearchControl from "../components/controls/AnalysesSearchControl.svelte";

    let client = null;
    let stats = {
        client_id: null,
        type_value: null,
        characterization_value: null,
        date_from: null,
        date_to: null,
        include_empty_samples: 1, // να εμφανίζονται και τα δείγματα χωρίς αναλύσεις ή χωρίς τιμές στις αναλύσεις τους
        analyses: [],
    }
    let analyses = [];
    // let statsResult = null;
    let pdfFilename = null;
    let noResults = false;
    let pdfError = false;
    // let sampleTypeInfo = {
    //     type: 'ΝΕΡΟ ΠΙΣΙΝΑΣ',
    //     total: 440,
    //     codes: [
    //         '1234567890',
    //         '1234567890',
    //     ]
    // }

    const load = () => {
        const onSuccess = result => {
            // statsResult = result;
            pdfFilename = result.filename;
        }

        const onFailure = err => {
            if (err.code && err.code === 'no_results') {
                noResults = true;
            } else {
                pdfError = true;
            }
        };

        if (!stats.client_id && !stats.type_value && !stats.characterization_value) {
            Alert.warning("Στατιστικά", "Ορίστε πελάτη ή είδος δείγματος ή χαρακτηρισμό δείγματος για στατιστικά.");
            return;
        }

        stats.analyses = analyses.map(item => ( item.id ));

        pdfFilename = null;
        noResults = false;
        pdfError = false;

        R.handle(R.sample.exportPdf, stats, onSuccess, onFailure, LOADER.POPUP);
    }

    const loadSampleTypeInfo = () => {
        // const onSuccess = result => {
        // }
        //
        // const onFailure = err => {
        //
        // };
        //
        //
        //
        // R.handle(R.sample.typeInfo, stats, onSuccess, onFailure, LOADER.POPUP);
    }

    const clearSearch = () => {
        client = null;
        stats.client_id = null;
        stats.type_value = null;
        stats.characterization_value = null;
        stats.date_from = null;
        stats.date_to = null;
        stats.analyses = [];

        // sampleTypeInfo = null;
        analyses = [];
        pdfFilename = null;
        noResults = false;
        pdfError = false;
    }


    const onClientChange = ({detail}) => {
        stats.client_id = detail ? detail.id : null;
    }

    const onTypeChange = ({detail}) => {
        if (stats.type_value != detail) {
            stats.type_value = detail;
            stats.characterization_value = null;
        }
    }

    const onTypeSelect = ({detail}) => {
        // console.log("onTypeSelect", detail);
        // loadSampleTypeInfo();
    }

    const onAnalysisSelect = ({detail}) => {
        console.log("onAnalysisSelect", detail);
        let item = analyses.find(x => x.id == detail.id);
        if (!item) {
            analyses = [{id: detail.id, code: detail.code, name: detail.name_el}, ...analyses];
        }
    }

    const onAnalysesRemove = (id) => {
        analyses = analyses.filter(x => x.id != id);
    }


    // client = {
    //     code: "3",
    //     company: "Source Development",
    //     email: "harrysnikoloudakis@gmail.com",
    //     id: 3,
    //     name: "Χάρης Νικολουδάκης",
    //     phone: "2815106377"
    // }
    // stats.client_id = 3;
    // stats.type_value = "ΝΕΡΟ ΠΙΣΙΝΑΣ";
</script>

<PageHeader title="Στατιστικά Pdf"/>
<div class="row">
    <div class="col-xl-3 col-lg-4">
        <div class="panel panel-simple p-2 mb-5">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-6">
                    <div class="form-group">
                        <label>Πελάτης</label>
                        <ClientControl bind:client={ client } allowEdit={ false } on:change={ onClientChange }/>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-6">
                    <div class="form-group">
                        <label>Είδος δείγματος</label>
                        <SampleTypeControl clientId="{ stats.client_id }" value="{ stats.type_value }"
                                           on:change={ onTypeChange }/>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <div class="form-group">
                        <label>Χαρακτηρισμός</label>
                        <SampleCharacterizationControl clientId="{ stats.client_id }"
                                                       bind:value="{ stats.characterization_value }"/>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-6">
                    <div class="form-group">
                        <label>Παράμετροι</label>
                        <AnalysesSelectControl on:select={ onAnalysisSelect }/>
                        {#if analyses.length}
                            <ul class="list-group analyses-list-group mt-1">
                                {#each analyses as item}
                                    <li class="list-group-item d-flex align-items-center position-relative px-2">
                                        <span class="code">{ item.code }</span>
                                        { item.name }
                                        <span class="remove" title="αφαίρεση ανάλυσης"
                                              on:click={ () => onAnalysesRemove(item.id) }>
                                            <AppIcon icon="x" size="16"/>
                                        </span>
                                    </li>
                                {/each}
                            </ul>
                        {/if}
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-6">
                    <label>Ημερομηνία</label>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <input type="date" class="form-control" bind:value="{ stats.date_from }">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <input type="date" class="form-control" bind:value="{ stats.date_to }">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <Checkbox label="Συμπεριλαμβανομένων των κενών αναλύσεων" bind:checked={stats.include_empty_samples}/>
            </div>
            <div class="row">
                <div class="col-6">
                    <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
                </div>
                <div class="col-6">
                    <button class="btn btn-outline btn-block" on:click={ load }>ΣΤΑΤΙΣΤΙΚΑ</button>
                </div>
            </div>
        </div>

        <!--{#if sampleTypeInfo}-->
        <!--    <div class="panel-simple panel-pad mb-5">-->
        <!--        <h6>{ sampleTypeInfo.type }</h6>-->
        <!--        <p class="mb-2">{ sampleTypeInfo.total } δείγματα</p>-->
        <!--        <div class="sample-info-codes">-->
        <!--            { sampleTypeInfo.codes.join(', ') }-->
        <!--        </div>-->
        <!--    </div>-->
        <!--{/if}-->
    </div>
    <div class="col-xl-9 col-lg-8">
        {#if pdfFilename}
            <object data="/documents/{ pdfFilename }" type="application/pdf" class="pdf-container">
                <p>Η εμφάνιση Pdf δεν υποστηρίζεται από τον browser σας.</p>
                <p>
                    Κατεβάστε το αρχείο από εδώ:<br>
                    <a href="/documents/{ pdfFilename }" target="_blank">{ pdfFilename }</a>
                </p>
            </object>
        {/if}
        {#if noResults}
            <div class="panel panel-simple panel-pad">
                Δεν βρέθηκαν αναλύσεις με τα κριτήρια που δηλώσατε!
            </div>
        {/if}
        {#if pdfError}
            <div class="text-center py-4">
                <div class="text-gray-1">
                    <AppIcon icon="exclamation-triangle-solid" size="50"/>
                </div>
                <p class="mt-3">Παρουσιάστηκε κάποιο σφάλμα κατά την δημιουργία του αρχείου!</p>
                <p>Πιθανόν να οφείλεται στον μεγάλο αριθμό αποτελεσμάτων.<br>Δοκιμάστε να μειώσετε τα αποτελέσματα
                    ορίζοντας περισσότερα φίλτρα στην αναζήτηση.</p>
            </div>
        {/if}
        <!--{#if statsResult}-->
        <!--    <table class="table table-list table-list-border table-stats mb-4">-->
        <!--        <tbody>-->
        <!--        {#if statsResult.client}-->

        <!--            <tr>-->
        <!--                <td class="th">ΚΩΔΙΚΟΣ ΠΕΛΑΤΗ:</td>-->
        <!--                <td class="data">{ statsResult.client.code }</td>-->
        <!--                <td class="th">ΔΙΕΥΘΥΝΣΗ:</td>-->
        <!--                <td class="data">{ statsResult.client.address }</td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--                <td class="th">ΕΠΩΝ. ΕΠΙΧΕΙΡΗΣΗΣ:</td>-->
        <!--                <td class="data">{ statsResult.client.company }</td>-->
        <!--                <td class="th">ΠΟΛΗ:</td>-->
        <!--                <td class="data">{ statsResult.client.city }</td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--                <td class="th">ΟΝΟΜΑ ΥΠΕΥΘΥΝΟΥ:</td>-->
        <!--                <td class="data">{ statsResult.client.name }</td>-->
        <!--                <td class="th">ΤΗΛΕΦΩΝΟ:</td>-->
        <!--                <td class="data">{ statsResult.client.phone }</td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--                <td class="th">ΕΙΔΟΣ ΕΠΙΧΕΙΡΗΣΗΣ:</td>-->
        <!--                <td class="data">{ statsResult.client.occupation }</td>-->
        <!--                <td class="th">EMAIL:</td>-->
        <!--                <td class="data">{ statsResult.client.email }</td>-->
        <!--            </tr>-->
        <!--            <tr class="blank-separator">-->
        <!--                <td colspan="4"></td>-->
        <!--            </tr>-->
        <!--        {/if}-->
        <!--        {#if statsResult.samples.length}-->
        <!--            {#each statsResult.samples as sample}-->
        <!--                <tr>-->
        <!--                    <td class="th">ΚΩΔΙΚΟΣ:</td>-->
        <!--                    <td class="data">{ sample.code }</td>-->
        <!--                    <td class="th">ΕΙΔΟΣ ΔΕΙΓΜΑΤΟΣ:</td>-->
        <!--                    <td class="data">{ sample.type }</td>-->
        <!--                </tr>-->
        <!--                <tr>-->
        <!--                    <td class="th">ΗΜ/ΝΙΑ ΔΕΙΓΜΑΤΟΛΗΨΙΑΣ:</td>-->
        <!--                    <td class="data">{ formatDate(sample.analysis_end_at, 'd-m-y') }</td>-->
        <!--                    <td class="th">ΧΑΡΑΚΤΗΡΙΣΜΟΣ:</td>-->
        <!--                    <td class="data">{ sample.characterization }</td>-->
        <!--                </tr>-->
        <!--                <tr class="separator">-->
        <!--                    <td colspan="4"></td>-->
        <!--                </tr>-->
        <!--                <tr>-->
        <!--                    <td class="th" colspan="2">ΠΑΡΑΜΕΤΡΟΣ</td>-->
        <!--                    <td class="th" colspan="2">ΑΠΟΤΕΛΕΣΜΑ</td>-->
        <!--                </tr>-->
        <!--                {#each sample.analyses as analysis}-->
        <!--                    <tr>-->
        <!--                        <td colspan="2">{ analysis.name_el }</td>-->
        <!--                        <td colspan="2">{ analysis.value }</td>-->
        <!--                    </tr>-->
        <!--                {/each}-->
        <!--                <tr class="blank-separator">-->
        <!--                    <td colspan="4"></td>-->
        <!--                </tr>-->
        <!--            {/each}-->
        <!--        {/if}-->
        <!--        </tbody>-->
        <!--    </table>-->
        <!--{/if}-->
    </div>
</div>

<style>
    /*.table-stats tr td {*/
    /*    padding: 10px;*/
    /*}*/

    /*.table-stats .th {*/
    /*    font-size: .8rem;*/
    /*    font-weight: normal;*/
    /*    letter-spacing: 1px;*/
    /*    color: #999;*/
    /*    width: 220px;*/
    /*}*/

    /*.table-stats td.data {*/
    /*    width: calc(50% - 220px);*/
    /*}*/

    /*.table-stats tr.blank-separator {*/
    /*    background: #f2f6f8;*/
    /*}*/

    /*.table-stats tr.blank-separator td {*/
    /*    height: 15px;*/
    /*    border-left: 1px solid #f2f6f8;*/
    /*    border-right: 1px solid #f2f6f8;*/
    /*    padding: 0;*/
    /*}*/

    /*.table-stats tr.blank-separator:last-child td {*/
    /*    border-bottom: 1px solid #f2f6f8;*/
    /*}*/

    /*.table-stats tr.separator td {*/
    /*    height: 2px;*/
    /*    background: #c6d2d9;*/
    /*    padding: 0;*/
    /*}*/


    .pdf-container {
        width: 100%;
    }

    .analyses-list-group li .code {
        display: inline-block;
        margin-right: 10px;
    }
    .analyses-list-group li .remove {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        cursor: pointer;
        padding: 5px;
    }

    .sample-info-codes {
        max-height: 192px;
        overflow-y: auto;
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .pdf-container {
            height: calc(100vh - 170px);
        }
    }

    @media (min-width: 1200px) {
        .pdf-container {
            height: calc(100vh - 200px);
        }
    }
</style>


